var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link, List, ListItem, Tooltip } from '@material-ui/core';
export function TagCloud(_a) {
    var tags = _a.tags, onLinkClick = _a.onLinkClick, LinkComponent = _a.LinkComponent;
    return (_jsx(List, { className: "faq-tag-cloud", children: tags.map(function (tag) {
            var props = {
                to: tag.link,
                onClick: onLinkClick ? function () { return onLinkClick(tag.link, {}); } : undefined,
                component: LinkComponent,
            };
            return (_jsx(ListItem, { className: "faq-tag-cloud__item", component: "li", children: _jsx(Tooltip, { title: tag.title, children: _jsx(Link, __assign({ color: "textSecondary", underline: "none", className: "faq-tag-cloud__item__link" }, props, { children: tag.title })) }) }, tag.link));
        }) }));
}
//# sourceMappingURL=TagCloud.js.map